import React, { useState } from "react";
import Icon from "components/AppIcon";

const FilterSidebar = ({
  selectedFilters,
  onFilterChange,
  onClearAll,
  searchTerm,
  onSearchChange,
  productTypeFilters,
}) => {
  const [expandedSections, setExpandedSections] = useState({
    productType: false,
    bodyType: true,
  });

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const hasActiveFilters =
    selectedFilters?.productType !== "all" ||
    selectedFilters?.bodyType !== "all" ||
    searchTerm?.length > 0;
  return (
    <>
      <div className="bg-surface border border-border rounded-lg p-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-heading-4 text-text-primary">Filters</h2>
          {hasActiveFilters && (
            <button
              onClick={onClearAll}
              className="text-sm text-primary hover:text-primary-700 transition-smooth"
            >
              Clear All
            </button>
          )}
        </div>

        <div className="mb-6">
          <label className="block text-sm font-medium text-text-primary mb-2">
            Search by Product Name
          </label>
          <div className="relative">
            <Icon
              name="Search"
              size={16}
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-secondary-400"
            />
            <input
              type="text"
              placeholder="Search by product name..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              className="w-full pl-10 pr-4 py-2 text-sm border border-border rounded-md focus-ring focus:border-primary"
            />
          </div>
        </div>

        {/* <div className="mb-6">
        <button
          onClick={() => toggleSection("bodyType")}
          className="flex items-center justify-between w-full text-left mb-3"
        >
          <span className="text-sm font-medium text-text-primary">
            Body Type
          </span>
          <Icon
            name={expandedSections?.bodyType ? "ChevronUp" : "ChevronDown"}
            size={16}
            className="text-secondary-400"
          />
        </button>

        {expandedSections?.bodyType && (
          <div className="space-y-2">
            {bodyTypes.map((type) => (
              <label
                key={type.value}
                className="flex items-center space-x-3 cursor-pointer"
              >
                <input
                  type="radio"
                  name="bodyType"
                  value={type.value}
                  checked={selectedFilters?.bodyType === type.value}
                  onChange={(e) => onFilterChange("bodyType", e.target.value)}
                  className="w-4 h-4 text-primary border-border focus:ring-primary"
                />
                <span className="text-sm text-text-primary">{type.label}</span>
              </label>
            ))}
          </div>
        )}
      </div> */}
        {productTypeFilters ? (
          <div className="mb-6">
            <button
              onClick={() => toggleSection("productType")}
              className="flex items-center justify-between w-full text-left mb-3"
            >
              <span className="text-sm font-medium text-text-primary">
                Category Type
              </span>
              <Icon
                name={
                  expandedSections?.productType ? "ChevronUp" : "ChevronDown"
                }
                size={16}
                className="text-secondary-400"
              />
            </button>

            {expandedSections?.productType && (
              <div className="space-y-2">
                <label className="flex items-center space-x-3 cursor-pointer">
                  <input
                    type="radio"
                    name="productType"
                    value="all"
                    checked={selectedFilters?.productType === "all"}
                    onChange={(e) =>
                      onFilterChange("productType", e.target.value)
                    }
                    className="w-4 h-4 text-primary border-border focus:ring-primary"
                  />
                  <span className="text-sm text-text-primary flex-1">
                    All Types
                  </span>
                </label>

                {productTypeFilters?.map((type) => (
                  <label
                    key={type.iCategoryId}
                    className="flex items-center space-x-3 cursor-pointer"
                  >
                    <input
                      type="radio"
                      name="productType"
                      value={type.iCategoryId}
                      checked={selectedFilters?.productType == type.iCategoryId}
                      onChange={(e) =>
                        onFilterChange("productType", parseInt(e.target.value))
                      }
                      className="w-4 h-4 text-primary border-border focus:ring-primary"
                    />
                    <span className="text-sm text-text-primary flex-1">
                      {type.sName}
                    </span>
                  </label>
                ))}
              </div>
            )}
          </div>
        ) : null}
      </div>
    </>
  );
};

export default FilterSidebar;
